export const DEFAULT_TAG_COLOR = '#007acc';